import gql from 'graphql-tag'

export const NAME = 'updateOrganization'
const UPDATE_ORG = gql`
mutation ${NAME}($organization: UpdateOrganizationInput!) {
  ${NAME}(org: $organization) {
    id
    parentId
    name
    isActive
    courseIds
    studentLimit
    numberOfSites
    notes
    type
    educationLevels
    contractStartDate
    contractEndDate
    country
    region
    selfManagedNotificationRoleTypes
    assessmentsEnabled
    baselineAnalysisEnabled
    baselineRecommendationsEnabled
    alternativeAssessmentEnabled
    sessionsEnabled
    roomsEnabled
    privateRoomsEnabled
    firewordsEnabled
    helpNotificationsEmails
    requireSessionPasswords
    openCourseIds
    parentCourseIds
    sevenMindsetsEnabled
    helpButtonDisabled
    firewordNotificationsThreshold
    studentAccessSchedule {
      timezone
      weeklyTimes {
        day
        startMinute
        endMinute
      }
      oneTimeExceptions {
        start {
          date
          month
          year
        }
        end {
          date
          month
          year
        }
      }
    }
  }
}
`

export default UPDATE_ORG
